<template>
  <div
    id="accessories"
    class="accessories"
  >
    <div class="accessories-left">
      <object
        ref="drawing"
        class="accessories-drawing"
        type="image/svg+xml"
        data="accessories-drawing.svg"
        width="250.3707733"
        height="383.4519958"
        @load="onDrawingLoad"
      />
    </div>
    <div class="accessories-body">
      <table class="accessories-table">
        <thead>
          <th>Комплектующие</th>
          <th>{{ currencySymbol }}/шт</th>
          <th>Кол-во</th>
          <th>Стоимость/{{ currencySymbol }}</th>
        </thead>
      </table>
      <div
        v-for="(row, i) in itemsByRows"
        :key="i"
        class="accessories-row"
      >
        <div class="accessories-num">
          РЯД {{ i + 1 }}
        </div>
        <table class="accessories-table">
          <tbody>
            <tr
              v-for="(item, j) in row.items"
              :key="j"
              @mouseenter="setDrawingDisplay(item.type + '_hover', true)"
              @mouseleave="setDrawingDisplay(item.type + '_hover', false)"
            >
              <td><span class="accessories-pseudo">{{ item.name }}</span></td>
              <td>{{ item.price }}</td>
              <td>{{ item.quantity }}</td>
              <td>{{ (item.price * item.quantity).toFixed(2) }}</td>
            </tr>
          </tbody>
        </table>
        <div class="accessories-summary">
          Стоимость ряда {{ i + 1 }}
          <div class="accessories-summaryPrice">
            {{ row.price }} {{ currencySymbol }}
          </div>
        </div>
      </div>
    </div>
    <div class="accessories-right">
      <div class="accessories-priceLabel">
        Итого:
      </div>
      <div class="accessories-price">
        {{ price }} {{ currencySymbol }}
      </div>
      <div class="accessories-icons">
        <a
          href="#"
          class="accessories-icon_print"
          title="Печать"
          @click.prevent="$emit('print')"
        />
        <a
          href="#"
          class="accessories-icon_download"
          title="Скачать"
          @click.prevent="$emit('download')"
        />
        <a
          href="#modal-calc-email"
          class="accessories-icon_mail"
          data-fancybox
          title="Отправить на почту"
        />
        <a
          v-if="role === 'dealer'"
          href="#modal-calc-invoice"
          class="accessories-icon_dealer"
          data-fancybox
          title="Выписать счет для дилера"
        />
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    inject: {
      currencySymbol: 'currencySymbol',
    },
    props: {
      itemsByRows: Array,
      wedgeAnchors: Boolean,
      pdfData: String,
      role: String
    },
    computed: {
      price() {
        return this.itemsByRows.reduce((a, c) => a + +c.price, 0).toFixed(2);
      },
      items() {
        return this.itemsByRows.reduce((a, c) => a.concat(c.items), []);
      },
      types() {
        return this.items.reduce((a, c) => ({...a, [c.type]: true}), {
          back_strips: false,
          side_strips: false,
          separators: false,
          back_screen: false,
          side_screen: false,
          back_wall: false,
          side_wall: false,
          thrusters_screw: false,
          thrusters: true,
        });
      },
    },
    watch: {
      types() {
        this.updateTypes();
      },
    },
    methods: {
      updateTypes() {
        for (const type in this.types) {
          this.setDrawingDisplay(type, this.types[type]);
        }
      },
      onDrawingLoad(e) {
        this.updateTypes();
      },
      getDrawingElement(id) {
        try {
          return this.$refs.drawing.getSVGDocument().getElementById(id);
        } catch(e) {
          return null;
        }
      },
      setElementDisplay(id, visible) {
        const el = this.getDrawingElement(id);
        if (el) {
          el.style.display = (visible ? 'block' : 'none');
        }
      },
      setDrawingDisplay(type, visible) {
        const typeMap = {
          rack_kit_hover: ['stoiki'],
          tier_shelf_hover: ['polki-orange'],
          tier_shelf_rib_hover: ['rebra'],
          fasteners_hover: ['krepezhi'],
          back_strips: ['planka-szadi'],
          back_strips_hover: ['planka-szadi-orange'],
          side_strips: ['planka-sprava1_1_', 'planka-sprava2', 'planka-sprava3', 'planka-sprava4'],
          side_strips_hover: ['planka-sprava-orange1_1_', 'planka-sprava-orange2', 'planka-sprava-orange3', 'planka-sprava-orange4'],
          separators: ['razdeliteli'],
          separators_hover: ['razdeliteli-orange'],
          back_screen: ['ekran-szadi_1_'],
          back_screen_hover: ['ekran-szadi-orange_1_'],
          side_screen: ['ekrani'],
          side_screen_hover: ['ekrani-orange'],
          back_wall: ['stenka-szadi'],
          back_wall_hover: ['stenka-szadi-orange'],
          side_wall: ['bokovaya-stenka-sleva'],
          side_wall_hover: ['bokovaya-stenka-sleva-orange'],
          thrusters_screw: ['opori'],
          thrusters_screw_hover: ['opori-orange'],
          thrusters: ['podpyatniki'],
          thrusters_hover: ['podpyatniki-orange'],
        };

        const types = typeMap[type] || [type];
        for (const type of types) {
          this.setElementDisplay(type, visible);
        }
      },
    },
  }
</script>

<style scoped>
  .accessories {
    display: flex;
    margin-top: 50px;
  }
  .accessories-left {
    width: 392px;
  }
  .accessories-body {
    flex: 1;
    margin-top: 20px;
  }
  .accessories-right {
    margin-top: 20px;
    margin-left: 30px;
    width: 226px;
  }
  .accessories-drawing {
    margin-left: 50px;
  }
  .accessories-table {
    width: 558px;
    font-size: 14px;
    border-collapse: collapse;
    table-layout: fixed;
  }
  .accessories-table th:nth-child(2),
  .accessories-table td:nth-child(2) {
    width: 88px;
  }
  .accessories-table th:nth-child(3),
  .accessories-table td:nth-child(3) {
    width: 77px;
  }
  .accessories-table th:nth-child(4),
  .accessories-table td:nth-child(4) {
    width: 139px;
  }
  .accessories-table th {
    padding: 14px;
    white-space: nowrap;
    text-align: left;
    font-weight: normal;
    background: #F6F6F6;
  }
  .accessories-table td {
    padding: 8px 14px;
  }
  .accessories-table tr:nth-child(2n + 1) td {
    background: #F6F6F6;
  }
  .accessories-table tr:hover {
    color: #0B53B3;
    cursor: pointer;
  }
  .accessories-pseudo {
    font-weight: bold;
    border-bottom: 1px dashed #333333;
  }
  .accessories-num {
    margin: 16px 14px 13px;
    font-weight: bold;
    text-transform: uppercase;
    color: #A7A7A7;
  }
  .accessories-summary {
    margin: 16px 0 40px;
    padding: 16px 14px;
    background: #F6F6F6;
  }
  .accessories-summaryPrice {
    float: right;
  }
  .accessories-priceLabel {
    font-weight: bold;
    font-size: 18px;
    text-transform: uppercase;
  }
  .accessories-price {
    margin-bottom: 46px;
    font-weight: bold;
    font-size: 30px;
  }
  .accessories-icons {
    margin-left: -6px;
  }
  .accessories-icon_print {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/print.svg) no-repeat center center;
  }
  .accessories-icon_download {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/download.svg) no-repeat center center;
  }
  .accessories-icon_mail {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/mail.svg) no-repeat center center;
  }
  .accessories-icon_dealer {
    display: inline-block;
    vertical-align: middle;
    width: 36px;
    height: 36px;
    background: url(../../public/icons/dealer.png) no-repeat center center;
  }
</style>
